import React from 'react';
import { Result, Button } from 'antd';
import { BtnLink } from './Buttons';

export default function UnavaibleScreen({ title, subTitle }) {

  return <Result
    status="500"
    title={title || "Estamos em manutenção"}
    subTitle={subTitle || "tente novamente mais tarde..."}
    extra={<div style={{ display: "flex", justifyContent: "center" }}>
      <div>
        <Button style={{ fontSize: 20, marginTop: 15 }} type="link" onClick={() => document.location.reload(true)}>Tentar novamente</Button>
        <BtnLink style={{ fontSize: 20, marginTop: 15, display: "block" }} showConfirm onClick={() => {
          localStorage.clear();
          document.location.reload(true);
        }}>Desconectar PDV</BtnLink>
      </div>
    </div>}
  />;
}
